import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { AbsiTemplateSectionCreate, AbsiTemplateSectionDelete, AbsiTemplateSectionRefresh, AbsiTemplateSectionTaskDelete, AbsiTemplateSectionUpdate } from './absi-template-section.action';
import { WfSignatureResource } from 'src/app/components/workflow/workflow';
import { utils } from 'src/app/modules/libs/utils';
import { AbsiBuilderService } from '../../absi-builder/absi-builder.service';
import { catchError, tap, throwError } from 'rxjs';
import { AbsiTemplateVersionUpdate } from '../absi-template/absi-template.action';

export class AbsiTemplateSectionStateModel {
  data: WfSignatureResource[] = [];
  requestedKeys: string[] = [];
}

@State<AbsiTemplateSectionStateModel>({
  name: 'AbsiTemplateSections',
  defaults: {
    data: [],
    requestedKeys: []
  }
})

@Injectable()
export class AbsiTemplateSectionState extends BaseState {

  constructor(
    protected override injector: Injector,
    private absiBuilderService: AbsiBuilderService,
    private store: Store

  ) {
    super(injector);
  }

  @Selector()
  static read(state: AbsiTemplateSectionStateModel) {
    return state.data;
  }



  @Action(AbsiTemplateSectionRefresh)
  refresh(ctx: StateContext<AbsiTemplateSectionStateModel>, { wfTableID, sectionNumber }: AbsiTemplateSectionRefresh) {
    if (!wfTableID) return;

    const key = `${wfTableID}:${sectionNumber}`;
    const state = ctx.getState();
    const TTL = 2000; // 2 seconds (adjust as needed)

    if (state.requestedKeys.includes(key)) return;

    ctx.patchState({ requestedKeys: [...state.requestedKeys, key] });

    return this.absiBuilderService.ReadWFBySection(wfTableID, sectionNumber).pipe(
      tap(data => {
        const current = ctx.getState().data;

        const newData = current
          .filter(x => !(x.wfTaskLocal.wfStepLocal?.wfSteps.at(-1)?.wfTableID === wfTableID && x.sectionNumber === sectionNumber))
          .concat(data);

        ctx.patchState({ data: utils.cloneDeep(newData) });

        // ⏳ Remove key after TTL
        setTimeout(() => {
          const s = ctx.getState();
          ctx.patchState({
            requestedKeys: s.requestedKeys.filter(k => k !== key)
          });
        }, TTL);
      }),
      catchError(err => {
        const s2 = ctx.getState();
        ctx.patchState({ requestedKeys: s2.requestedKeys.filter(k => k !== key) });
        return throwError(() => err);
      })
    );
  }

  @Action(AbsiTemplateSectionCreate)
  create({ getState, patchState }: StateContext<AbsiTemplateSectionStateModel>, { item }: AbsiTemplateSectionCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(AbsiTemplateSectionUpdate)
  update(ctx: StateContext<AbsiTemplateSectionStateModel>, { id, item }: AbsiTemplateSectionUpdate) {

    this.store.dispatch(new AbsiTemplateVersionUpdate(item.template.id!, item.template));

    const current = ctx.getState().data;
    const incoming = item.section.wfSignatures ?? [];

    const newData = current
      .filter(x => !(x.wfTaskLocal.wfStepLocal?.wfSteps.at(-1)?.wfTableID === item.section.wfTableID && x.sectionNumber === id))
      .concat(incoming);

    ctx.patchState({ data: utils.cloneDeep(newData) });
  }

  @Action(AbsiTemplateSectionDelete)
  delete({ getState, patchState }: StateContext<AbsiTemplateSectionStateModel>, { id }: AbsiTemplateSectionDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id)
    });
  }

  @Action(AbsiTemplateSectionTaskDelete)
  deleteTask({ getState, patchState }: StateContext<AbsiTemplateSectionStateModel>, { wfTableID, sectionNumber, wfTaskLocalID }: AbsiTemplateSectionTaskDelete) {
    patchState({
      data: getState().data.filter(x =>
        !(
          x.wfTaskLocal?.wfStepLocal?.wfSteps.at(-1)?.wfTableID === wfTableID &&
          x.sectionNumber === sectionNumber &&
          x.wfTaskLocal?.id === wfTaskLocalID
        )
      )
    });
  }

}
